// Normalize proj4 in all environments and load EPSG defs
import * as proj4ns from "proj4";
import defs from "proj4js-definitions";

const proj4 = (proj4ns as any).default ?? (proj4ns as any);
proj4.defs(defs);

// also expose globally for libs that look for window.proj4
(window as any).proj4 = proj4;

export default proj4;
export { proj4 }; // named export if anyone cares
